import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DefaultSharedModule } from '@homeleite/default-shared';
import { LayoutAdminModule } from './admin/layout-admin.module';
import { LayoutBaseModule } from './base/layout-base.module';

const MODULES = [
  LayoutAdminModule,
  LayoutBaseModule
]


@NgModule({
  declarations: [
  ],
  imports: [
    CommonModule,
    DefaultSharedModule,
    ...MODULES
  ],
  exports: MODULES
})
export class LayoutModule { }
